import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent, computed, nextTick, watch, reactive, ref, onMounted, toRefs } from 'vue';
import apis from "@/api";
export default {
  name: "IopEvent",
  props: {
    positionId: {
      type: String,
      default: ''
    },
    channelCode: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const table = ref({});
    let data = reactive({
      positionName: '',
      visible: false,
      selectioned: '',
      paginationObj: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      channels: [],
      positionTypes: [],
      tableData: [],
      loading: false,
      showWarn: false,
      queryParam: {
        channelCode: props.channelCode
      }
    });
    const dialogCheck = (selection, row) => {
      table.value.clearSelection();
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return;
      }
      if (row) {
        data.selectioned = row;
        nextTick(() => {
          table.value.toggleRowSelection(row, true);
        });
      }
    };
    const handleSelectionChange = selection => {
      data.selectioned = selection;
    };
    const handleSizeChange = val => {
      data.paginationObj.pageSize = val;
      loadEvents();
    };
    const handleCurrentChange = val => {
      data.paginationObj.pageNo = val;
      loadEvents();
    };
    const loadEvents = () => {
      data.queryParam.channelCode = props.channelCode;
      apis.iopCPPage({
        ...data.queryParam,
        ...data.paginationObj
      }).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          for (const t of data.tableData) {
            if (t.positionCode === props.positionId) {
              nextTick(() => {
                table.value.toggleRowSelection(t, true);
              });
            }
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleOk = () => {
      if (data.selectioned.length > 0) {
        data.positionName = data.selectioned[0].positionName;
        ctx.emit("update:positionId", data.selectioned[0].positionCode);
        data.visible = false;
      } else {
        data.showWarn = true;
      }
    };
    const loadPositionName = () => {
      nextTick(() => {
        if (props.positionId) {
          apis.getPositionByCode({
            positionCode: props.positionId
          }).then(res => {
            if (res.success) {
              data.positionName = res.data.positionName;
            }
          });
        }
      });
    };
    const loadChannels = () => {
      apis.getChannels().then(res => {
        if (res.success) {
          data.channels = res.data;
        }
      });
    };
    const loadPositionTypes = () => {
      apis.getPositionTypes({
        channelCode: props.channelCode
      }).then(res => {
        if (res.success) {
          data.positionTypes = res.data;
        }
      });
    };
    const resetQuery = () => {
      data.queryParam = {
        channelCode: props.channelCode
      };
      loadEvents();
    };
    watch(() => [data.selectioned, props.positionId, props.channelCode], ([v1, newPid, newPc], [v0, oldPid, oldPc]) => {
      if (newPid && !oldPid) {
        loadPositionName();
      }
      if (newPc) {
        loadPositionTypes();
      }
      data.showWarn = v1.length <= 0;
    });
    onMounted(() => {
      nextTick(() => {
        loadChannels();
      });
    });
    return {
      ...toRefs(data),
      table,
      dialogCheck,
      handleSelectionChange,
      handleCurrentChange,
      handleSizeChange,
      handleOk,
      loadEvents,
      resetQuery
    };
  }
};